import React, { PureComponent } from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import ExchangeRates from './ExchangeRates'
import ExchangeCol from './StyledExchangeCol'
import { RegularRow } from '../../utils/Grid'
import ExchangeWrapper from './StyledExchangeWrapper'
import {
  EXCHANGE_FORM,
  EXCHANGE_FORMAT_REGEXP
} from '../../../constants'

export default class Exchange extends PureComponent {
  constructor (props) {
    super(props)

    const {
      widget: {
        boxes
      }
    } = props

    const currencies = {}

    boxes.forEach(({ guid: currency, exchangeRate: rate }) => {
      currencies[currency] = {
        rate,
        currencyAmount: '1.00',
        czkAmount: `${rate}`
      }
    })

    this.state = {
      currencies
    }

    this.handleCurrencyChange = this.handleCurrencyChange.bind(this)
  }

  calculateExchangeRate (stringValue, rate, direction) {
    let czkAmount = 0
    let currencyAmount = 0
    const numericValue = parseFloat(stringValue.replace(',', '.'))

    if (direction === EXCHANGE_FORM.OPERATIONS[0].value) {
      czkAmount = !(stringValue === '' || stringValue === '---') ? rate * numericValue : '---'
      currencyAmount = stringValue
    } else if (direction === EXCHANGE_FORM.OPERATIONS[1].value) {
      czkAmount = stringValue
      currencyAmount = !(stringValue === '' || stringValue === '---') ? numericValue / rate : '---'
    }

    return {
      currencyAmount,
      czkAmount
    }
  }

  formatExchangeRate ({ currencyAmount, czkAmount }, hasComma) {
    return {
      currencyAmount: typeof currencyAmount !== 'string' ? this.floatToString(currencyAmount, hasComma) : currencyAmount,
      czkAmount: typeof czkAmount !== 'string' ? this.floatToString(czkAmount, hasComma) : czkAmount
    }
  }

  floatToString (numericValue, hasComma) {
    let stringValue = numericValue.toFixed(2)

    if (hasComma) {
      stringValue = stringValue.replace('.', ',')
    }

    return stringValue
  }

  handleCurrencyChange (currency, amount, direction) {
    const {
      currencies
    } = this.state

    if (!(new RegExp(EXCHANGE_FORMAT_REGEXP).test(amount) || amount === '' || amount === '---')) {
      return false
    }

    const hasComma = amount.indexOf(',') > -1

    const newAmounts = this.calculateExchangeRate(amount, currencies[currency].rate, direction)
    const formattedAmounts = this.formatExchangeRate(newAmounts, hasComma)
    const newCurrencies = Object.assign({}, currencies, {
      [currency]: Object.assign({}, currencies[currency], formattedAmounts)
    })

    this.setState({
      currencies: newCurrencies
    })
  }

  render () {
    const {
      widget,
      activeDynamicLayout
    } = this.props

    const {
      currencies
    } = this.state

    return (
      <WidgetContainer widget={widget} activeDynamicLayout={activeDynamicLayout}>
        <RegularRow>
          <ExchangeCol>
            <ExchangeWrapper>
              <ExchangeRates currencies={currencies} handleCurrencyChange={this.handleCurrencyChange}/>
            </ExchangeWrapper>
          </ExchangeCol>
        </RegularRow>
      </WidgetContainer>
    )
  }
}
